import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import React from 'react';
import { Link } from 'react-router-dom';

const linkStyle = { color: 'rgba(0, 0, 0, 0.87)' };

interface HeaderListItemProps {
    text: string;
    url: string;
    Icon: React.ReactNode;
}

export const HeaderListItem: React.FC<HeaderListItemProps> = ({ text, url, Icon }) => (
    <ListItem component={Link} to={url} style={linkStyle}>
        <ListItemButton disableRipple>
            <ListItemIcon>{Icon}</ListItemIcon>
            <ListItemText primary={text} />
        </ListItemButton>
    </ListItem>
);
